import Index from "./Index.page";

export default Index;
